const Menu =  [
  {
    title: 'Encargos',
    group: 'tablero',
    icon: 'dashboard',
    name: 'Tablero',
    component: 'tablero',
    roles: [ 1,4 ],
  },
  {
    title: 'Trámites IBA',
    group: 'data',
    component: 'newData',
    icon: 'add_circle_outline',
    roles: [ 1,2,4 ],
    items: [
      { name: 'Tramites Masivos', title: 'Tramites Masivos', component: 'NewData', roles: [ 1,2,4 ] },
      { name: 'Gestiones', title: 'Gestiones', component: 'dataCreate', roles: [ 1,2,4 ] },
      { name: 'Historial', title: 'Historial', component: 'dataHistory', roles: [ 1,2,4 ] },
      { name: 'Agentes',title: 'Archivos', component: 'Agentes' ,roles: [ 1,2,4 ],},
      {children:[{
        name: 'Agentes',title: 'Archivos', component: 'Agentes' ,roles: [ 1,2,4 ]
      }]}
    ]
  },
  {
    title: 'Documentos IBA',
    group: 'archivo',
    icon: 'person',
    roles: [ 1,3,4 ],
    items: [
      { name: 'Nuevo', title: 'Nuevo', component: 'agenteArchivoCrear', roles: [ 1,3,4 ] },
      { name: 'Historial', title: 'Historial', component: 'agenteArchivoHistoria', roles: [ 1,3,4 ] },
      { name: 'Archivos', title: 'Archivos', component: 'Archivos', roles: [ 1,3,4 ] },
    ]
  },
  
  {
    title: 'Usuarios',
    group: 'usuarios',
    icon: 'person',
    name: 'Usuarios',
    roles: [ 1 ],
  },
  {
    title: 'Cerrar sesión',
    group: 'logout',
    icon: 'exit_to_app',
    name: 'logOut',
    roles: [ 1,2,3,4 ],
  }
];

export default Menu;
